import * as React from 'react';
import { useMemo } from 'react';
import { Box, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';

interface StorageColumnProps {
  selectedUserId: number | null;
  selectedSiteId: number | null;
  selectedStorageId: number | null;
  storages: StorageType[];
  onStorageClick: (storageId: number) => void;
}

const StorageColumn: React.FC<StorageColumnProps> = ({
  selectedSiteId,
  selectedStorageId,
  storages,
  onStorageClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const uniqueStorages = useMemo(
    () =>
      storages.filter(
        (storage, index, all) => all.findIndex((item) => item.id === storage.id) === index
      ),
    [storages]
  );

  return (
    <Grid size={{ xs: 3 }} sx={{ borderLeft: theme.palette.border, p: 1, display: 'flex', flexDirection: 'column' }}>
      {selectedSiteId === null ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont,
          }}
        >
          {t('storages:t.selectStorage')}
        </Box>
      ) : uniqueStorages.length === 0 ? (
        <Box
          sx={{
            alignItems: 'center',
            ...theme.typography.placeHolderFont,
          }}
        >
          {t('storages:t.noStorages')}
        </Box>
      ) : (
        uniqueStorages.map((storage) => (
          <Box
            key={storage.id}
            onClick={() => onStorageClick(storage.id)}
            sx={{
              display: 'flex',
              height: '30px',
              minHeight: '30px',
              paddingLeft: '12px',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              ...theme.typography.usersFontTitle,
              cursor: 'pointer',
              borderRadius: '4px',
              backgroundColor: selectedStorageId === storage.id ? 'rgba(0, 128, 0, 0.08)' : 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(0, 128, 0, 0.12)',
              },
              mb: 1,
            }}
          >
            {storage.name}
          </Box>
        ))
      )}
    </Grid>
  );
};

export default StorageColumn;
